module.exports = __webpack_public_path__ + "img/Banner_R&C.e327563e.png";